export default __webpack_public_path__ + "static/media/fatigue_mark.af2fdc92.png";